import styled from '@emotion/styled';
import isNil from 'lodash-es/isNil';
import * as React from 'react';
import { CSSLengthUnit } from '~/utils/css';

const IconImg = styled.img<{ size?: string; verticalAlign?: string }>`
  width: ${({ size }) => (size ? size : '25px')};
  height: ${({ size }) => (size ? size : '25px')};
  vertical-align: ${({ verticalAlign }) => (isNil(verticalAlign) ? 'middle' : verticalAlign)};
`;

const Container = styled.div<{ size?: string }>`
  width: ${({ size }) => (size ? size : '25px')};
  position: relative;
`;

export type IconProps = {
  src: string;
  alt: string;
  // Accepts any CSS unit for width
  size?: CSSLengthUnit;
  imgVerticalAlign?: 'middle' | 'top' | 'bottom';
  className?: string;
  children?: React.ReactNode;
};

const Icon = ({ src, alt, size, className, children, imgVerticalAlign }: IconProps) => {
  return (
    <Container size={size} className={className}>
      <IconImg src={src} alt={alt} size={size} verticalAlign={imgVerticalAlign} />
      {children}
    </Container>
  );
};

const ComposedIcon = React.memo(Icon);

export default ComposedIcon as React.ComponentType<IconProps>;
